@if (compact()) {
  <!-- Vignette du fil : portrait serré dans une pastille ronde -->
  <span class="koffi__puck">
    <img class="koffi__img" [src]="avatarSrc" [alt]="label" width="256" height="256" decoding="async" />
  </span>
} @else {
  <!-- Halo doux derrière la mascotte, qui pulse pendant l'écoute et la parole -->
  <span class="koffi__halo" aria-hidden="true"></span>

  <!--
    Les quatre poses sont empilées et seule la courante est opaque : changer
    `src` ferait clignoter l'image le temps du chargement, le fondu évite ce
    saut. Seule la pose visible est exposée aux lecteurs d'écran.
  -->
  @for (pose of states; track pose) {
    <img
      class="koffi__img koffi__pose"
      [class.koffi__pose--active]="pose === state()"
      [src]="poses[pose]"
      [attr.alt]="pose === state() ? label : ''"
      [attr.aria-hidden]="pose === state() ? null : 'true'"
      width="512"
      height="512"
      decoding="async"
    />
  }
}
